import React from 'react';
import { NavLink } from 'react-router-dom';
import ResultsGroupView from '../ResultsGroupView';
import SummaryTable from '../summarytable/SummaryTable';
import AssetTile from '../assetTile/AssetTile';

const SensorByFloorView = ({ pointTypesByFloor, location, handlePointTypeSelection, cols }) => {
  const pointTypesByFloorResults = pointTypesByFloor.map((floor) => ({
    name: floor.name,
    items: floor.pointsByType.map((pointType) => (
      <AssetTile
        key={`${floor.name}-${pointType.pointTypeName}`}
        flipEnabled
        flipLabel="Compare >"
        frontSubtitle={pointType.pointTypeName}
        frontLeftInfo={`Units: ${new Set(pointType.points.map((p) => p.equipId)).size}`}
        frontRightInfo={`Points: ${pointType.points.length}`}
        frontDrilldownFunc={(e) =>
          handlePointTypeSelection(e, pointType.pointTypeId, floor.floorNum)
        }
        frontDrilldownEnabled
        backDrilldownFunc={(e) =>
          handlePointTypeSelection(e, pointType.pointTypeId, floor.floorNum)
        }
        backDrilldownLabel="Details"
        backLeftInfo={pointType.pointTypeName}
        backRightInfo={`Points: ${pointType.points.length}`}
        backTileContent={
          <SummaryTable
            table={{
              cols,
              rows: pointType.points.map((p) => ({
                id: p.pointId,
                values: [
                  <NavLink
                    key={p.pointId}
                    to={`${location.pathname}/asset/${location.search}&eid=${p.equipId}`}
                  >
                    {p.equipName}
                  </NavLink>,
                  `${p.value} ${p.units}`,
                ],
              })),
            }}
          />
        }
      />
    )),
  }));
  return <ResultsGroupView loading={false} groups={pointTypesByFloorResults} />;
};

export default SensorByFloorView;
